export default "__VITE_ASSET__DQKT84AF__"